
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { Global } from 'src/app/services/global';
import { HttpClient } from '@angular/common/http';
import { ModuleService } from 'src/app/services/module.service';
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
// import { MediaDialogComponent } from 'src/app/media/media-dialog/media-dialog.component';
declare const $: any;

@Component({
  selector: 'app-theme-details',
  templateUrl: './theme-details.component.html',
  styleUrls: ['./theme-details.component.css']
})

export class ThemeDetailsComponent implements OnInit {

  @Input() selectedTheme: any;
  @Output() result = new EventEmitter<any>();
  @ViewChild('content', { read: ViewContainerRef, static: true }) content: ViewContainerRef;

  searchText = '';
 
  css: any = '';
  site: any = {}
  tempColor: any = {};
  tempClass: any = '';
  global: Global;
  tempFonts: any = {};
  indexToEdit: number = null;
  tempImports: any = {};
  className: string;
  options: any = {
    'indent_size': 1,
    'indent_char': ' ',
    'eol': '\n',
    'indent_level': 0,
    'max_preserve_newlines': 10,
    'wrap_line_length': 0,
    'operator_position': 'before-newline',
    'brace_style': 'collapse',
    'indent_scripts': 'normal',
    'indent_with_tabs': true,
    'preserve_newlines': true,
    'end_with_newline': false,
    'editorconfig': false,
    'space_in_paren': false,
    'space_in_empty_paren': false,
    'jslint_happy': false,
    'space_after_anon_function': false,
    'space_after_named_function': false,
    'unindent_chained_methods': false,
    'break_chained_methods': false,
    'keep_array_indentation': true,
    'unescape_strings': false,
    'e4x': false,
    'comma_first': false,
    'eval_code': false,
    'space_before_conditional': true,
    'indent-inner-html': false
  };
  jsScript: boolean = true;
  importFiles: boolean = false;
  imports: any[] = [];
  viewGallery: boolean;

  constructor(private httpClient: HttpClient, global: Global, private moduleService: ModuleService, public dialog: MatDialog) {
    this.global = global;
  }

  ngOnInit() {

    this.selectedTheme.colors = this.selectedTheme.colors || []
    this.selectedTheme.classes = this.selectedTheme.classes || []
    this.selectedTheme.fonts = this.selectedTheme.fonts || []
    this.selectedTheme.styles = this.selectedTheme.styles || ''
    this.selectedTheme.scripts = this.selectedTheme.scripts || ''
    this.selectedTheme.importFiles = this.selectedTheme.importFiles || []

  }

  AddImports() {
    if (this.indexToEdit == null)
      this.selectedTheme.importFiles.push(this.tempImports);
    else
      this.selectedTheme.importFiles[this.indexToEdit] = JSON.parse(JSON.stringify(this.tempImports))
    this.indexToEdit = null;
    this.tempImports = {}
  }

  editImports(data, i) {
    this.tempImports = JSON.parse(JSON.stringify(data));
    this.indexToEdit = i;
  }
  del(c, i) {
    this.selectedTheme.importFiles.splice(i, 1);
  }

  AddColors() {
    if (this.indexToEdit == null)
      this.selectedTheme.colors.push(this.tempColor);
    else
      this.selectedTheme.colors[this.indexToEdit] = JSON.parse(JSON.stringify(this.tempColor))
    this.indexToEdit = null;
    this.tempColor = {}
  }

  editColor(color, i) {
    this.tempColor = JSON.parse(JSON.stringify(color));
    this.indexToEdit = i;
  }


  AddClass(className) {
    if (this.indexToEdit == null)
      this.selectedTheme.classes.push(className);
    else
      this.selectedTheme.classes[this.indexToEdit] = className
    this.indexToEdit = null;
    this.beautify('css');
    this.className = ''

  }

  editClass(className, i) {
    this.className = JSON.parse(JSON.stringify(className));
    this.indexToEdit = i;
  }

  AddFont() {

    if (this.tempFonts.IsPrimary) {
      for (let i = 0; i < this.selectedTheme.fonts.length; i++) {
        const f = this.selectedTheme.fonts[i];
        f.IsPrimary = false;
      }
    }

    if (this.indexToEdit == null)
      this.selectedTheme.fonts.push(this.tempFonts);
    else
      this.selectedTheme.fonts[this.indexToEdit] = JSON.parse(JSON.stringify(this.tempFonts))
    this.indexToEdit = null;
    this.beautify('css');
    this.tempFonts = {}
  }

  editFont(temp, i) {
    this.tempFonts = JSON.parse(JSON.stringify(temp));
    this.indexToEdit = i;
  }

  onFilesAdded(event, drop) {

  }

  beautify(type) {
    if (type == 'css') {
      this.options['indent_size'] = 1;
      this.selectedTheme.styles = this.global.beautify[type](this.selectedTheme.styles, this.options);
    }
    // if (type == 'javascript') {
    //   this.options['indent_size'] = 4;
    //   this.selectedTheme.importFiles.scripts = this.global.beautify[type](this.selectedTheme.importFiles.scripts, this.options);
    // }
  }
  openImportsTabs(type) {
    if (type == 'js') {
      this.jsScript = true
      this.importFiles = false
    }
    else {
      this.jsScript = false
      this.importFiles = true
    }
  }
  openGallery() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    dialogConfig.data = { isMultiSelect: false,files: ["image",'webp']  };

    // let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     console.log('result : ',result)
    //     // this.tempMenu.thumbnailId = result.id;
    //     this.selectedTheme.thumbnailURL = result.publicUrl;
    //     //this.selectedTheme.importFiles.push(result.publicUrl)
    //     //console.log("urlxxx",  this.selectedTheme.thumbnailURL)
    //    // this.selectedTheme.importFiles=result.publicUrl
    //   }
    // });
  }
  // openGalery() {

  //   var x = this.moduleService.ComponentFactory['GalleryComponent'];
  //   if (this.moduleService.ComponentFactory['GalleryComponent']) {
  //     this.viewGallery = true
  //     this.content.clear();
  //     // create setting component
  //     const component: any = this.content.createComponent(x);
  //     setTimeout(() => {
  //       $(".theme-media-gallery").hide();
  //     }, 0);
  //     // sending @Input() values 
  //     component.instance.data = { multi: true, enviroment: window['config'] };
  //     //  save @output() 
  //     component.instance.imgUrl.subscribe(res => {
  //       if (res && res != null) {
  //         for (var i = 0; i < res.length; i++) {
  //           var fileType = res[i].contentType
  //           var link = window['config'].apiUrl + '/' + res[i].publicUrl
  //           while (link.indexOf('\\') !== -1) {
  //             link = link.replace('\\', '/');
  //           }
  //           this.selectedTheme.importFiles.push({ fileName: res[i].fileName, type: fileType, link: link });
  //         }
  //       }
  //       this.viewGallery = false
  //       this.content.clear();
  //       setTimeout(() => {
  //         $(".theme-media-gallery").show();
  //       }, 0);
  //     });
  //   }

  // }
}